'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import GlobalStyles from '@mui/material/GlobalStyles';
import { Palette } from '@classify/react-core-components/styles';
import { Theme } from '@classify/react-core-components/Theme';
import LocalizationProvider, { type Props as LocalizationProviderProps } from '@classify/react-core-components/LocalizationProvider';
interface Props {
  children: ReactNode;
  language?: string;
  overrides?: any;
}
const RootWrapper = t0 => {
  const $ = _c(9);
  const {
    language: t1,
    children,
    overrides: t2
  } = t0;
  const language = t1 === undefined ? "en" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const overrides = t3;
  const cssOverride = _temp;
  const t4 = language as LocalizationProviderProps['locale'];
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <GlobalStyles styles={cssOverride} />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== children || $[4] !== t4) {
    t6 = <LocalizationProvider locale={t4}>{children}{t5}</LocalizationProvider>;
    $[3] = children;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== overrides || $[7] !== t6) {
    t7 = <Theme overrides={overrides}>{t6}</Theme>;
    $[6] = overrides;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default RootWrapper;
function _temp(t0) {
  const {
    palette
  } = t0;
  return {
    ":root": {
      interpolateSize: "allow-keywords"
    },
    html: {
      background: palette.layout.background.main,
      fontSize: "1rem"
    },
    body: {
      margin: 0,
      fontFamily: "Inter, sans-serif",
      color: palette.text.primary
    },
    a: {
      color: "var(--clf-text-on-main)",
      "&:hover": {
        color: "var(--clf-brand-primary)"
      }
    }
  };
}